(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("marketUi", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["marketUi"] = factory(require("vue"));
	else
		root["marketUi"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__285__) {
return 